import { Component, OnInit } from '@angular/core';
import { ASSETS } from '@env';
import { AchievementProvider } from '@providers/achievement/achievement';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { AuthProvider } from '@providers/auth/auth';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'modal-insignia',
  templateUrl: 'modal-insignia.html'
})
export class ModalInsigniaComponent implements OnInit{


  ICONS_ACHIEVEMENTS = ASSETS.ICONS_ACHIEVEMENTS;
  show: boolean;
  _insignia: any;
  DESCRIPTIONS: any = { };
  private $insignias: Array<any>;
  private container: any;
  private jugador: Jugador;
  private equipo: Equipo;

  readonly AUDIO_GANAR_INSIGNIA = 'assets/audios/obtencion_insignia_.wav';
  private audio = new Audio();

  constructor(
    public achievementProvider: AchievementProvider,
    private authProvider: AuthProvider,
    private translate: TranslateService
  ) {

    this.DESCRIPTIONS = {
      'PREGUNTAS_CONTESTADAS'       : this.translate.instant('modalInsignia.goals.PREGUNTAS_CONTESTADAS'),
      'PREGUNTAS_CORRECTAS'         : this.translate.instant('modalInsignia.goals.PREGUNTAS_CORRECTAS'),
      'RETOS_PERSONALES_JUGADOS'    : this.translate.instant('modalInsignia.goals.RETOS_PERSONALES_JUGADOS'),
      'RETOS_PERSONALES_GANADOS'    : this.translate.instant('modalInsignia.goals.RETOS_PERSONALES_GANADOS'),
      'PUNTOS_ACUMULADOS'           : this.translate.instant('modalInsignia.goals.PUNTOS_ACUMULADOS'),
      'COMPETENCIAS_EQUIPO_GANADAS' : this.translate.instant('modalInsignia.goals.COMPETENCIAS_EQUIPO_GANADAS'),
    };
  }

  ngOnInit(): void {
    this.buscaNuevasInsignias();
  }

  async buscaNuevasInsignias() {
    try {
      this.jugador = await this.authProvider.getSession();
      this.equipo = await this.authProvider.getEquipo();

      let insignias = await this.achievementProvider.verificaNuevasInsignias(this.equipo.area._id, this.equipo._id, this.jugador._id);
      if(insignias && insignias.length > 0){
          this.present(insignias);

          this.audio.src = this.AUDIO_GANAR_INSIGNIA;
          this.audio.load();
          this.audio.play();
      }
    } catch (error) { }

    // return this.authProvider.getSession()
    //   .then( jugador => {
    //     this.jugador = jugador;
    //     return this.authProvider.getEquipo();
    //   })
    //   .then( equipo => {
    //     this.equipo = equipo;
    //     return this.achievementProvider.verificaNuevasInsignias(this.equipo.area._id, this.equipo._id, this.jugador._id)
    //   })
    //   .then( insignias => {
    //     if(insignias && insignias.length > 0){
    //         this.present(insignias);
    //
    //         this.audio.src = this.AUDIO_GANAR_INSIGNIA;
    //         this.audio.load();
    //         this.audio.play();
    //     }
    //   });
  }

  assingValue(values: any) {
    if(Array.isArray(values)) {
      this.$insignias = values;
    } else {
      this.$insignias = [values];
    }

    this._insignia = this.$insignias.shift();

  }

  handlerEvents(): void {

    setTimeout( () => {
      this.container = document.getElementById("container-achievement-item");

      let animationEnd = (function(el) {
        let animations = {
          animation: 'animationend',
          OAnimation: 'oAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          WebkitAnimation: 'webkitAnimationEnd',
        };

        for (let t in animations) {
          if (el.style[t] !== undefined) {
            return animations[t];
          }
        }
      })(document.createElement('div'));

      this.container.addEventListener(animationEnd, () => {
        this.container.classList.remove("animated",  "bounceInLeft", "delay-2s");
      });
    });
  }

  getDescription(): string {
    let description = this.DESCRIPTIONS[this._insignia.tipo];
    switch(this._insignia.tipo) {
      case 'PREGUNTAS_CONTESTADAS':
        return description.replace('{hito}', this._insignia.preguntasContestadas);

      case 'PREGUNTAS_CORRECTAS':
        return description.replace('{hito}', this._insignia.preguntasCorrectas);

      case 'RETOS_PERSONALES_JUGADOS':
        return description.replace('{hito}', this._insignia.retosPersonalesJugados);

      case 'RETOS_PERSONALES_GANADOS':
        return description.replace('{hito}', this._insignia.totalGanados);

      case 'PUNTOS_ACUMULADOS':
        return description.replace('{hito}', this._insignia.puntosAcumulados);

      case 'COMPETENCIAS_EQUIPO_GANADAS':
        return description.replace('{hito}', this._insignia.competenciasEquipoGanadas);

    }

    return 'Sin descripción';
  }

  cerrar() {
    this._insignia = this.$insignias.shift();
    if(!this._insignia) {
        this.dismiss();
    } else {
      this.container.classList.add("animated", "bounceInLeft", "delay-2s");
    }
  }

  dismiss() {
    this.show = false;
  }

  present(insignia: any) {
    this.show = true;
    this.assingValue(insignia);
    this.handlerEvents();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-insignia/modal-insignia.ts